import { useDispatch, useSelector } from 'react-redux'
import { updateBatchComments } from '../../../actions/batchManagementActions';
import UniDialog from '../../../components/Common/UniDialog';
import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import FullscreenLoading from '../../../components/Common/FullscreenLoading';

export default function AddEditComment(props) {
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();

    const { openModal, onClose, commentOri, warehouse, batches, handleCommentUpdate } = props;

    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        setComment(event.target.value);
    }

    useEffect(() => {
        setComment(commentOri);
    }, [commentOri])

    return (
        <>
            <UniDialog
                title={t('button_add_edit_batch_comment')}
                maxWidth='sm'
                open={openModal}
                onClose={handleClose}
                fullWidth={true}
                onFinish={handleSubmit}
            >
                <TextField 
                    multiline 
                    variant="outlined"
                    rows={3}
                    value={comment}
                    fullWidth={true}
                    onChange={handleChange}
                    id='main-batchmanagement-editaddcomment-textfield'
                />
            </UniDialog>
            <FullscreenLoading open={loading} />
        </>
    );

    function handleClose() {    
        onClose();
    };

    function handleSubmit() {
        setLoading(true);
        dispatch(updateBatchComments(batches, warehouse, comment))
        .then(() => {
            handleCommentUpdate(comment);
            dispatch(showAlertSnackbar({message:t('update_description_success'), type:'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message:t('update_description_failure'), type:'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }
}

AddEditComment.defaultProps = {
    handleCommentUpdate: () => {}
}